import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { EligibilityResponsePayload } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/eligibility.interface';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { CustomValidators } from 'src/app/shared/directives/custom-validators';
import { DateService } from 'src/app/shared/services/date.service';
//import * as moment from 'moment';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PageIndividualOnExchangePlanEnrollmentService } from '../../services/page-individual-on-exchange-plan-enrollment.service';
import { TaxFilerFormControlsAsJson } from 'src/app/angular-elements/shared/interfaces/on-exchange-eligibility-form.interface';

interface TaxFilerFormControls {
  attestation: AbstractControl;
  primaryTaxFiler: AbstractControl;
  jointTaxFiler: AbstractControl;
}

// interface TaxFilerFormControlsAsJson {
//   attestation: boolean;
//   primaryTaxFiler: string;
//   jointTaxFiler: string;
// }

@FormComponentLookup('marketplace-advance-premium-tax-credit')
@Component({
    selector: 'app-marketplace-advance-premium-tax-credit',
    templateUrl: './marketplace-advance-premium-tax-credit.component.html',
    styleUrls: ['./marketplace-advance-premium-tax-credit.component.scss'],
    standalone: false
})
export class MarketplaceAdvancePremiumTaxCreditComponent extends FormEntryComponentClass implements OnInit, OnDestroy {

  mustAttest: boolean;
  taxFilerForm: UntypedFormGroup;
  taxFilerFormChangesSubscription: Subscription;

  taxFilerNames: string;
  signOrSubmissionDate: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dateService: DateService,
    private pageIndividualOnExchangePlanEnrollmentService: PageIndividualOnExchangePlanEnrollmentService
  ) {
    super();
  }

  get taxFilerFormControls(): TaxFilerFormControls {
    return this.taxFilerForm.controls as unknown as TaxFilerFormControls;
  }

  ngOnDestroy() {
    this.taxFilerFormChangesSubscription?.unsubscribe();
  }

  ngOnInit(): void {

    this.signOrSubmissionDate = moment(this.dateService.getNow()).format('MM/DD/YYYY');

    const eligibilityState: OnExchangeEligibilityStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];
    const matchedProspects = eligibilityState.prospects.filter(p => eligibilityState.currentProspectId === p.prospectId );

    if (matchedProspects.length > 0) {
      const prospect = matchedProspects[0];
      if (prospect.data.APTC) {
        this.mustAttest = prospect.data.APTC;

        /** Create Form */
        this.taxFilerForm = this.fb.group({});
        /** Watch Form */
        this.setupSubscription();
        /** Populate Form */
        this.setupForm(prospect.data);
      }
    }

  }

  setupSubscription() {

    this.taxFilerFormChangesSubscription = this.taxFilerForm.valueChanges
    .pipe(debounceTime(300))
    .subscribe((v: TaxFilerFormControlsAsJson) => {

      const dynamicObject = {};
      dynamicObject[this.entry.formControlAttributes.formControlName] = v;

      /** Update global form (trigger save to state) */
      this.form.patchValue(dynamicObject);
      this.pageIndividualOnExchangePlanEnrollmentService.reportValidity(this.taxFilerForm, this.entry);

    });

  }

  setupForm(enrollData: EligibilityResponsePayload) {

    /** Attestion Checkbox */
    this.taxFilerForm.addControl(
      'attestation',
      this.fb.control(false, [Validators.requiredTrue])
    );

    /** Primary Signature */
    const primaryFilerFullName = `${enrollData.primaryTaxFilerPersonReference.fullName.firstName} ${enrollData.primaryTaxFilerPersonReference.fullName.lastName}`;
    this.taxFilerNames = primaryFilerFullName;
    this.taxFilerForm.addControl(
      'primaryTaxFiler',
      this.fb.control(null, [
        Validators.required,
        CustomValidators.valueExactlyMatchesInput(primaryFilerFullName)
      ]));

    /** Joint Signature (additionally) */
    if (enrollData.jointTaxFilerPersonReference) {
      const jointFilerFullName = `${enrollData.jointTaxFilerPersonReference.fullName.firstName} ${enrollData.jointTaxFilerPersonReference.fullName.lastName}`;
      this.taxFilerNames = `${primaryFilerFullName}, ${jointFilerFullName}`;
      this.taxFilerForm.addControl(
        'jointTaxFiler',
        this.fb.control(null, [
          Validators.required,
          CustomValidators.valueExactlyMatchesInput(jointFilerFullName)
        ]));
    }

    this.taxFilerForm.updateValueAndValidity();
    this.pageIndividualOnExchangePlanEnrollmentService.reportValidity(this.taxFilerForm, this.entry);
  }


}
